import { Typography } from "@mui/material";
import ConsoleSidebar, { type ConsoleNavEntry, type ConsoleSidebarPalette } from "../console/ConsoleSidebar";
import { T } from "./tokens";

export type TandemView =
    | "overview"
    | "schedule"
    | "reports"
    | "pool"
    | "consultants"
    | "settings"
    | "points"
    | "engine";

const NAV: ConsoleNavEntry<TandemView>[] = [
    { header: "Monitor" },
    { key: "overview", label: "Overview" },
    { key: "schedule", label: "Schedule" },
    { key: "reports", label: "Reports" },
    { key: "pool", label: "Visit pool" },
    { key: "consultants", label: "Consultants" },
    { header: "Configure" },
    { key: "settings", label: "Settings" },
    { key: "points", label: "Points model" },
    { key: "engine", label: "Engine settings" },
];

const PALETTE: ConsoleSidebarPalette = {
    background: T.ink,
    text: T.sidebarText,
    muted: T.sidebarMuted,
    hover: T.sidebarHover,
    activeText: "#fff",
    accent: T.purple,
};

const Sidebar = ({
    active,
    onNavigate,
    hiddenPages,
}: {
    active: TandemView;
    onNavigate: (v: TandemView) => void;
    hiddenPages?: Set<TandemView>;
}) => (
    <ConsoleSidebar
        brand={
            <>
                <Typography sx={{ fontWeight: 800, fontSize: "19px", letterSpacing: "-0.01em", color: "#fff" }}>
                    Tandem
                </Typography>
                <Typography
                    sx={{ fontSize: "11px", color: T.sidebarMuted, mt: "2px", letterSpacing: "0.06em", textTransform: "uppercase" }}
                >
                    WorkNest Tools · H&amp;S Visits
                </Typography>
            </>
        }
        onBrandClick={() => onNavigate("overview")}
        items={NAV}
        active={active}
        onNavigate={onNavigate}
        palette={PALETTE}
        hiddenKeys={hiddenPages}
    />
);

export default Sidebar;
